import { render, staticRenderFns } from "./view-layout.m.vue?vue&type=template&id=2a194140&scoped=true"
import script from "./view-layout.m.vue?vue&type=script&lang=js"
export * from "./view-layout.m.vue?vue&type=script&lang=js"
import style0 from "./view-layout.m.vue?vue&type=style&index=0&id=2a194140&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a194140",
  null
  
)

export default component.exports